<template>
  <div class="fixWidth container-fluid">
    <v-dialog v-model="formDialogStatus" max-width="1200px">
      <formDialog
        :dialogStatus.sync="formDialogStatus"
        :editedData="editedItem"
        :indexEdited.sync="editedIndex"
      ></formDialog>
    </v-dialog>
    <v-dialog v-model="deleteDialogStatus" max-width="600px">
      <deleteDialog
        v-on:changeTitle="updateTitleData($event)"
        v-on:changeStat="closeDelDialog($event)"
      ></deleteDialog>
    </v-dialog>
 

    <template>
      <v-expansion-panels focusable>
        <v-expansion-panel class="mb-3">
          <v-expansion-panel-header
            >Custom Search Panel</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-container class="fixWidth">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="searchParam.title"
                    label="Title"
                    class="mt-3"
                  ></v-text-field>
                </v-col>
       <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                name="Title"
                :item-text="(item) => item.title"
                item-value="id"
                v-model="searchParam.category_id"
                chips
                :items="getInventoryCategoryItem"
              
              >
              <template v-slot:label>
                  Category Name<strong style="color: red">*</strong>
                </template>
                <template v-slot:selection="data">
                  <v-chip color="grey lighten-4" :input-value="data.selected">
                    <span class="subheading">{{
                      data.item.title
                    }}</span>
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
                    <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                name="Title"
                :item-text="(item) => item.institute_name_en"
                item-value="id"
                v-model="searchParam.institute_id"
                chips
                :items="getInstituteItem"
               
              >
              <template v-slot:label>
                  Institute Name<strong style="color: red">*</strong>
                </template>
                <template v-slot:selection="data">
                  <v-chip color="grey lighten-4" :input-value="data.selected">
                    <span class="subheading">{{
                      data.item.institute_name_en
                    }}</span>
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
              </v-row>
            </v-container>
            <v-card-actions>
              <v-layout justify-center>
                <v-btn
                  color="primary  white--text"
                  
                  @click.stop.prevent="searchInventorySubCategory()"
                  >Search</v-btn
                >
                <v-btn
                  color="red  white--text"
                  
                  class="ml-2"
                  @click.stop.prevent="clearData()"
                  >cancel</v-btn
                >
                <span></span>
              </v-layout>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
    <snackbar :snacksProp="snackBar" />
    <v-data-table
      :headers="headers"
      :items="getInventorySubCategoryItem"
      :server-items-length="totalItems"
      :options.sync="pagination"
      :footer-props="pagination.rowsPerPageItems"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Inventory Sub-Category List</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="newItem"
            v-if="functionalAccess.add =='1'"
            >Add New Inventory Sub-Category</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:item.id="{ item, index }">
        {{index+((pagination.page-1)*pagination.itemsPerPage)+1}}
      </template>
     
      <template v-slot:item.actions="{ item }">
      
        <v-icon small class="mr-2" color="primary" v-if="functionalAccess.edit =='1'" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small color="red" v-if="functionalAccess.delete =='1'" @click="deleteDialogOpen(item)">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click=""> Reset </v-btn>
      </template>
    </v-data-table>
  </div>
</template>
 <script>
import formDialog from "@/components/inventory/inventorySubCategoryForm.vue";
import deleteDialog from "@/components/utils/deleteDialog.vue";
import snackbar from "@/components/utils/snackbar.vue";
import functionalMixin from "../../mixins/searchFunction";

export default {
  components: {
    formDialog,
    deleteDialog,
    snackbar,
  },
  mixins: [
    functionalMixin
  ],
  data() {
    return {
      pagination: {
        itemsPerPage: 10,
        rowsPerPageItems: { "items-per-page-options": [5, 10, 25, 100, 200] },
      },
      detailData: {},
      detailDialogStatus: false,

      totalItems: null,
      
      search: "",
      
      editedItem: {},
      editedIndex: -1,
      loading: false,
      title: "tiiii",
      dialog: false,
      formDialogStatus: false,
      deleteDialogStatus: false,
     
      deleteId: {},
      searchParam: {},
      searchString: "",
     
      snackBar: {
        control: false,

        multiline: true,
        text: {
          message: "hi",
        },
      },
      headers: [
        { text: "Serial No.", value: "id", sortable: false },
        { text: "Title", value: "title", sortable: false },
        { text: "Institute", value: "institute.institute_name_en", sortable: false },
        
        { text: "Actions", value: "actions", sortable: false },
      ],
   
      editedIndex: -1,
    };
  },
  created() {
  	this.$store.dispatch("callInstitueData", {
      page: 1,
      size: -1
    });
    	this.$store.dispatch("callInventoryCategoryList", {
      page: 1,
      size: -1
    });
  },
  computed: {
    getInventorySubCategoryItem() {
      return this.$store.getters.getInventorySubCategoryItem;
    },
         getInventoryCategoryItem() {
      return this.$store.getters.getInventoryCategoryItem;
    },
    getInstituteItem() {
      return this.$store.getters.getInstituteItem;
    },
    getTitle() {
      return this.title;
    },
    getResponseMessage() {
      return this.$store.getters.getResponseMessage;
    },
    getErrorMessage(state) {
      return this.$store.getters.getErrorMessage;
    },
 
  },
  watch: {
    getTitle(val) {
      if (val == "confirmed") {
        this.deleteItem();
      }
    },
    pagination() {
      this.searchInventorySubCategory();
    },
    getResponseMessage(val) {
      this.snackBar.text.message = val.message;
      this.snackBar.control = true;
    },
    getErrorMessage(val) {
     //  console.log("val asada", val.message);
      let myObject = val.message;
      for (const [key, value] of Object.entries(myObject)) {
        this.snackBar.text.message = value[0];
        this.snackBar.control = true;
      }
    },
  },
  methods: {
    getItemPerPage(val) {
     //  console.log(val);
      this.pagination.rowsPerPage = val;
      this.setLimit();
    },
    setLimit() {
      const { page, itemsPerPage } = this.pagination;
      this.searchParam.page = page;
      this.searchParam.size = itemsPerPage;
    },
        searchInventorySubCategory() {
      this.loading = true;
      this.searchString = "";
      if (this.searchParam.institute_id) {
        this.searchString = `institute_id=${this.searchParam.institute_id}`;
      }
       if (this.searchParam.category_id) {
        if (this.searchString == "") {
          this.searchString = `category_id=${this.searchParam.category_id}`;
        } else {
          this.searchString = `${this.searchString} and category_id=${this.searchParam.category_id}`;
        }
      }
 
      if (this.searchParam.title) {
        if (this.searchString == "") {
          this.searchString = `title like '%${this.searchParam.title}%'`;
        } else {
          this.searchString = `${this.searchString} and title like '%${this.searchParam.title}%'`;
        }
      }
     
    

      encodeURIComponent(this.searchString);
      this.$store
        .dispatch("callInventorySubCategoryList", {
          page: this.pagination.page,
          size: this.pagination.itemsPerPage,
          search: this.searchString,
        })
        .then((data) => {
          this.loading = false;
         //  console.log("data cal ", data.total);
          this.totalItems = data.total;
        });
    },
    // searchInventorySubCategory() {
        
    //     if(this.searchParam.title){
    //         this.searchString = `${this.searchString} and title like '%${this.searchParam.title}%'`;
    //     }
    //     if(this.searchParam.description){
    //         this.searchString = `${this.searchString} and description like '%${this.searchParam.description}%'`;
    //     }
    //     if(this.searchParam.published_date_start){
    //       this.searchString = `${this.searchString} and published_date>='${this.searchParam.published_date_start}'`;
    //     }
    //     if(this.searchParam.published_date_end){
    //       this.searchString = `${this.searchString} and published_date<='${this.searchParam.published_date_end}'`
    //     }
    //     // encodeURIComponent(this.searchString);
    //     this.$store.dispatch('callInventorySubCategoryList', {
    //         page: this.pagination.page,
    //         size: this.pagination.itemsPerPage,
    //         search: this.searchString,
    //     }).then((res)=>{
    //         this.totalItems = res.total;
    //     });
    // },
   

    dialogOpen() {
      this.formDialogStatus = true;
    },
    closeDelDialog(deleteDialogStatus) {
      this.deleteDialogStatus = false;
    },
    updateTitleData(title) {
      this.title = title;
    },
    newItem() {
      this.dialogOpen();
    },
  
    editItem(item) {
      this.editedIndex = this.getInventorySubCategoryItem.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$store.commit("SET_INVENTORY_SUB_CATEGORY_SCHEMA", this.editedItem);
      this.dialogOpen();
    },
    clearData(){
       this.searchParam.title = "";
       this.searchParam.category_id = "";
        this.searchParam.institute_id = "";

    },
    deleteDialogOpen(item) {
      this.deleteId = item.id;
      this.deleteDialogStatus = true;
    },
    async deleteItem() {
      // const id = item.id;
      let self = this;
      await this.$store
        .dispatch("deleteInventorySubCategoryData", this.deleteId)
        .then(function (data) {
          try {
            self.title = "";
            self.deleteDialogStatus = false;
          } catch (ex) {
           //  console.log(ex);
          }
        })
        .catch(function (error) {
         //  console.log(error);
        });
        this.searchInventoryCategory();
    },
  
  },
};
</script>
<style>
.v-data-table th {
  font-size: 14px !important;
}
.fixWidth{
  width: auto;
}
</style>
